import { i as e, n as t, r as n, t as r } from "./RadioGroup-BV93AAf9.mjs";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
import * as s from "react";
import { Fragment as c, cloneElement as l, useEffect as u, useId as d, useLayoutEffect as f, useMemo as p, useRef as m, useState as h } from "react";
import * as g from "react-dom";
//#region \0rolldown/runtime.js
var _ = Object.create, v = Object.defineProperty, y = Object.getOwnPropertyDescriptor, b = Object.getOwnPropertyNames, x = Object.getPrototypeOf, S = Object.prototype.hasOwnProperty, C = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), w = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = b(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !S.call(e, s) && s !== n && v(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = y(t, s)) || r.enumerable
	});
	return e;
}, T = (e, t, n) => (n = e == null ? {} : _(x(e)), w(t || !e || !e.__esModule ? v(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), E = {
	"arrows.arrow-right": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M17.92 11.62a1 1 0 0 0-.21-.33l-5-5a1.003 1.003 0 1 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l5-5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76"
		})
	}),
	"arrows.chevron-down": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42"
		})
	}),
	"arrows.trending-up": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.92 6.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 6h-5a1 1 0 0 0 0 2h2.59L13 13.59l-3.29-3.3a1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219L9 12.41l3.29 3.3a1 1 0 0 0 1.42 0L20 9.41V12a1 1 0 0 0 2 0V7a1 1 0 0 0-.08-.38"
		})
	}),
	"cloud-and-web.two-columns": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M11 20H4V4h7zm9 0h-7V4h7z"
		})
	}),
	"file-and-folder.add-document": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3zm-4-5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.add-file": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M20 18h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-7 2H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v3a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L15.59 8H14a1 1 0 0 1-1-1zM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5 8H8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m1-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.add-folder": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M14 12.5h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 0 0 0-2m5-7h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .584.187c.17.122.298.294.366.493l.54 1.64a1 1 0 0 0 .365.493A1 1 0 0 0 12 7.5h7a1 1 0 0 1 1 1z"
		})
	}),
	"file-and-folder.archive": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M10 13h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m9-10H5a3 3 0 0 0-1 5.82V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.82A3 3 0 0 0 19 3m-1 15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h12zm1-11H5a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2"
		})
	}),
	"file-and-folder.document": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M9 10h1a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zm11-3.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3zm-3-3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.restore": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M11.44 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 1 1 11.44 20a1 1 0 1 0 0 2 10 10 0 0 0 0-20m0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1"
		})
	}),
	"medical.add-book": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M13 9h-2V7a1 1 0 0 0-2 0v2H7a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 0 0 0-2m5 6V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M4 15V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m17-9a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1"
		})
	}),
	"medical.ambulance": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M10.5 9.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 0 0 0-2m12.43 2.15-.06-.11a.6.6 0 0 0-.07-.14l-2.4-3.2A3 3 0 0 0 18 7h-2V6a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v11a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-.07-.35M6 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2m8-3H8.22a3 3 0 0 0-4.44 0H3V6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1zm2-7h2a1 1 0 0 1 .8.4L20 11h-4zm2 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3-3h-.78a3 3 0 0 0-4.22-.22V13h5z"
		})
	}),
	"medical.stethoscope": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.8 10c-.4-1.2-1.6-2-2.8-2-1.7 0-3 1.3-3 3 0 1.3.8 2.4 2 2.8v1.7c0 2.5-2 4.5-4.5 4.5S9 18 9 15.5v-.6c2.9-.5 5-3 5-5.9V3c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1h1v5c0 2.2-1.8 4-4 4s-4-1.8-4-4V4h1c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1 .4-1 1v6c0 2.9 2.1 5.4 5 5.9v.6c0 3.6 2.9 6.5 6.5 6.5s6.5-2.9 6.5-6.5v-1.7c1.6-.5 2.4-2.2 1.8-3.8"
		})
	}),
	"security.lock": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 1 1 6 0v2H9zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"
		})
	}),
	"security.shield": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M19.63 3.65a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27A1 1 0 0 0 4 4.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78M18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39zm-4.46-2.29-2.69 2.7-.89-.9a1.004 1.004 0 0 0-1.42 1.42l1.6 1.6a1 1 0 0 0 1.42 0L15 11a1.004 1.004 0 1 0-1.42-1.42z"
		})
	}),
	"sign-and-symbol.block": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 0 1-8-8 7.92 7.92 0 0 1 1.69-4.9L16.9 18.31A7.92 7.92 0 0 1 12 20m6.31-3.1L7.1 5.69A7.92 7.92 0 0 1 12 4a8 8 0 0 1 8 8 7.92 7.92 0 0 1-1.69 4.9"
		})
	}),
	"user-interface.checkmark-circle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20"
		})
	}),
	"user-interface.checkmark": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 10 7",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M9.155.197a.667.667 0 0 0-.947 0L3.241 5.171 1.155 3.077a.681.681 0 1 0-.947.98l2.56 2.56a.667.667 0 0 0 .947 0l5.44-5.44a.667.667 0 0 0 0-.98"
		})
	}),
	"user-interface.close-bold": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 8 8",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m4.944 4.003 2.867-2.86a.67.67 0 0 0-.947-.947l-2.86 2.867L1.144.196a.67.67 0 0 0-.947.947l2.867 2.86-2.867 2.86a.667.667 0 0 0 .217 1.092.67.67 0 0 0 .73-.146l2.86-2.866 2.86 2.866a.666.666 0 0 0 1.092-.217.67.67 0 0 0-.145-.73z"
		})
	}),
	"user-interface.close": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m13.41 12 6.3-6.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1 1 0 0 0 1.42 0 1 1 0 0 0 .219-1.095 1 1 0 0 0-.22-.325z"
		})
	}),
	"user-interface.dislike": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M19 2H6.27a3 3 0 0 0-2.95 2.46l-1.27 7A3 3 0 0 0 5 15h4.56L9 16.43A4.13 4.13 0 0 0 12.89 22a1 1 0 0 0 .91-.59L16.65 15H19a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-4 11.79-2.72 6.12a2.13 2.13 0 0 1-1.38-2.78l.53-1.43A2 2 0 0 0 9.56 13H5a1 1 0 0 1-.77-.36 1 1 0 0 1-.23-.82l1.27-7a1 1 0 0 1 1-.82H15zM20 12a1 1 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1z"
		})
	}),
	"user-interface.exclamation-mark-circle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m.38-3.92a1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1.2 1.2 0 0 0-.21.33 1 1 0 0 0 .21 1.09q.147.133.33.21A1 1 0 0 0 13 8a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-.33-.21M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20"
		})
	}),
	"user-interface.exclamation-mark-triangle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53m-1.73 2a1 1 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02zM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"
		})
	}),
	"user-interface.house": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m20 8-6-5.26a3 3 0 0 0-4 0L4 8a3 3 0 0 0-1 2.26V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8.75A3 3 0 0 0 20 8m-6 12h-4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm5-1a1 1 0 0 1-1 1h-2v-5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1v-8.75a1 1 0 0 1 .34-.75l6-5.25a1 1 0 0 1 1.32 0l6 5.25a1 1 0 0 1 .34.75z"
		})
	}),
	"user-interface.like": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.3 10.08A3 3 0 0 0 19 9h-4.56L15 7.57A4.13 4.13 0 0 0 11.11 2a1 1 0 0 0-.91.59L7.35 9H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12.73a3 3 0 0 0 2.95-2.46l1.27-7a3 3 0 0 0-.65-2.46M7 20H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2zm13-7.82-1.27 7a1 1 0 0 1-1 .82H9v-9.79l2.72-6.12a2.11 2.11 0 0 1 1.38 2.78l-.53 1.43a2 2 0 0 0 1.87 2.7H19a1 1 0 0 1 .77.36 1 1 0 0 1 .23.82"
		})
	}),
	"user-interface.magnifier": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m19.785 18.649-2.968-2.944a7.2 7.2 0 1 0-1.112 1.112l2.944 2.944a.8.8 0 0 0 1.136 0 .8.8 0 0 0 0-1.112m-8.568-1.832a5.6 5.6 0 1 1 0-11.2 5.6 5.6 0 0 1 0 11.2"
		})
	}),
	"user-interface.move": (e) => /* @__PURE__ */ o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: [
			/* @__PURE__ */ a("circle", {
				cx: 9,
				cy: 6,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 9,
				cy: 12,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 9,
				cy: 18,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 15,
				cy: 6,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 15,
				cy: 12,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 15,
				cy: 18,
				r: 2,
				fill: "currentColor"
			})
		]
	}),
	"user-interface.paper-plane": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m20.34 9.32-14-7a3 3 0 0 0-4.08 3.9l2.4 5.37a1.06 1.06 0 0 1 0 .82l-2.4 5.37A3 3 0 0 0 5 22a3.14 3.14 0 0 0 1.35-.32l14-7a3 3 0 0 0 0-5.36zm-.89 3.57-14 7a1 1 0 0 1-1.35-1.3l2.39-5.37a2 2 0 0 0 .08-.22h6.89a1 1 0 0 0 0-2H6.57a2 2 0 0 0-.08-.22L4.1 5.41a1 1 0 0 1 1.35-1.3l14 7a1 1 0 0 1 0 1.78"
		})
	}),
	"user-interface.pen": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-15 .76V17a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .71-.29l6.92-6.93L21.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71m10.76-8.35 2.83 2.83-1.42 1.42-2.83-2.83zM8 13.17l5.93-5.93 2.83 2.83L10.83 16H8z"
		})
	}),
	"user-interface.setting": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m21.32 9.55-1.89-.63.89-1.78A1 1 0 0 0 20.13 6L18 3.87a1 1 0 0 0-1.15-.19l-1.78.89-.63-1.89A1 1 0 0 0 13.5 2h-3a1 1 0 0 0-.95.68l-.63 1.89-1.78-.89A1 1 0 0 0 6 3.87L3.87 6a1 1 0 0 0-.19 1.15l.89 1.78-1.89.63a1 1 0 0 0-.68.94v3a1 1 0 0 0 .68.95l1.89.63-.89 1.78A1 1 0 0 0 3.87 18L6 20.13a1 1 0 0 0 1.15.19l1.78-.89.63 1.89a1 1 0 0 0 .95.68h3a1 1 0 0 0 .95-.68l.63-1.89 1.78.89a1 1 0 0 0 1.13-.19L20.13 18a1 1 0 0 0 .19-1.15l-.89-1.78 1.89-.63a1 1 0 0 0 .68-.94v-3a1 1 0 0 0-.68-.95M20 12.78l-1.2.4A2 2 0 0 0 17.64 16l.57 1.14-1.1 1.1-1.11-.6a2 2 0 0 0-2.79 1.16l-.4 1.2h-1.59l-.4-1.2A2 2 0 0 0 8 17.64l-1.14.57-1.1-1.1.6-1.11a2 2 0 0 0-1.16-2.82l-1.2-.4v-1.56l1.2-.4A2 2 0 0 0 6.36 8l-.57-1.11 1.1-1.1L8 6.36a2 2 0 0 0 2.82-1.16l.4-1.2h1.56l.4 1.2A2 2 0 0 0 16 6.36l1.14-.57 1.1 1.1-.6 1.11a2 2 0 0 0 1.16 2.79l1.2.4zM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
		})
	})
}, D = {
	violet: "violet",
	blue: "blue",
	green: "green",
	lilac: "lilac",
	yellow: "yellow",
	grey: "grey",
	red: "red",
	white: "white"
}, O = (e) => e === D.white ? "var(--color-white)" : `var(--color-${e}-500)`, k = ({ name: e, size: t = 24, color: n = D.violet, ariaLabel: r }) => {
	let i = E[e], o = O(n);
	return /* @__PURE__ */ a(i, {
		"aria-hidden": !r || void 0,
		"aria-label": r,
		color: o,
		height: t,
		role: r ? "img" : void 0,
		width: t
	});
}, A = [
	"primary",
	"accent",
	"link",
	"danger",
	"neutral"
], j = [
	"solid",
	"outline",
	"ghost"
], M = [
	"xs",
	"s",
	"m",
	"l"
], N = {
	leading: "leading",
	trailing: "trailing"
}, P = ({ children: e, icon: t, iconColor: n, iconPosition: r, iconSize: i = 16, "aria-label": s, intent: c = "primary", variant: l = "solid", size: u = "l", type: d, ...f }) => {
	let p = !(typeof e == "string" && e.trim().length > 0), m = [
		"button",
		`intent-${c}`,
		`variant-${l}`,
		`size-${u}`,
		...p ? ["icon-only"] : []
	].join(" "), h = t ? /* @__PURE__ */ a(k, {
		ariaLabel: p ? s : void 0,
		color: n,
		name: t,
		size: i
	}) : null;
	return /* @__PURE__ */ o("button", {
		"aria-label": s,
		className: m,
		type: d ?? "button",
		...f,
		children: [
			p || r === N.leading ? h : null,
			e,
			!p && r === N.trailing ? h : null
		]
	});
}, F = {
	default: "default",
	warning: "warning"
}, ee = {
	small: "small",
	medium: "medium",
	large: "large"
}, te = {
	lilac: "lilac",
	blue: "blue",
	yellow: "yellow",
	violet: "violet",
	red: "red",
	green: "green",
	grey: "grey",
	gradient: "gradient"
}, ne = 16, re = (e) => {
	let { children: t, size: n = ee.medium, className: r, type: i = F.default, color: s = te.lilac, icon: c, ...l } = e, u = i === F.warning, d = c !== void 0 && n !== ee.small ? c : void 0, f = (u ? [
		"badge",
		"badge-type-warning",
		`badge-size-${n}`,
		r
	] : [
		"badge",
		"badge-type-default",
		`badge-color-${s}`,
		`badge-size-${n}`,
		r
	]).filter(Boolean).join(" "), p = d == null ? void 0 : E[d];
	return /* @__PURE__ */ o("span", {
		className: f,
		...l,
		children: [p == null ? null : /* @__PURE__ */ a("span", {
			className: "badge-icon-slot",
			children: /* @__PURE__ */ a(p, {
				"aria-hidden": !0,
				width: ne,
				height: ne
			})
		}), /* @__PURE__ */ a("span", {
			className: "badge-text",
			children: t
		})]
	});
}, ie = {
	large: "large",
	medium: "medium",
	micro: "micro"
}, ae = {
	violet: "violet",
	blue: "blue",
	green: "green",
	lilac: "lilac",
	yellow: "yellow",
	grey: "grey"
}, oe = {
	filled: "filled",
	outlined: "outlined"
}, se = {
	idle: "idle",
	active: "active",
	disabled: "disabled"
}, ce = 18, le = 10, ue = (e) => {
	let { children: t, frontIcon: n, variant: r = oe.outlined, size: i = ie.large, color: s = ae.violet, state: c = se.idle, removable: l = !1, onRemove: u, className: d, ...f } = e, p = c === se.disabled, m = [
		"chip",
		`chip-variant-${r}`,
		`chip-size-${i}`,
		`chip-color-${s}`,
		`chip-state-${c}`,
		d
	].filter(Boolean).join(" "), h = (e) => {
		e.stopPropagation(), !p && u && u();
	};
	return /* @__PURE__ */ o("span", {
		className: m,
		...f,
		children: [
			n == null ? null : /* @__PURE__ */ a("span", {
				className: "chip-icon-slot",
				children: /* @__PURE__ */ a(k, {
					name: n,
					size: ce
				})
			}),
			/* @__PURE__ */ a("span", {
				className: "chip-text",
				children: t
			}),
			l && u ? /* @__PURE__ */ a("button", {
				type: "button",
				className: "chip-remove-button",
				onClick: h,
				disabled: p,
				"aria-label": "Remove",
				children: /* @__PURE__ */ a(k, {
					name: "user-interface.close",
					size: le
				})
			}) : null
		]
	});
}, I = /* @__PURE__ */ T((/* @__PURE__ */ C(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var t = [], r = 0; r < arguments.length; r++) {
				var i = arguments[r];
				if (i) {
					var a = typeof i;
					if (a === "string" || a === "number") t.push(i);
					else if (Array.isArray(i)) {
						if (i.length) {
							var o = n.apply(null, i);
							o && t.push(o);
						}
					} else if (a === "object") if (i.toString === Object.prototype.toString) for (var s in i) e.call(i, s) && i[s] && t.push(s);
					else t.push(i.toString());
				}
			}
			return t.join(" ");
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})))()), de = {
	small: "small",
	medium: "medium"
}, fe = {
	leading: "leading",
	trailing: "trailing"
}, pe = {
	small: 14,
	medium: 16
}, me = (e, t) => {
	let n = e.iconPosition ?? fe.leading, r = e.text === void 0, s = e.icon === void 0 ? null : /* @__PURE__ */ a(k, {
		name: e.icon,
		size: t
	});
	return /* @__PURE__ */ o(i, { children: [
		n === fe.leading && s,
		!r && /* @__PURE__ */ a("span", {
			className: "tab-label",
			children: e.text
		}),
		n === fe.trailing && s
	] });
}, he = (e) => {
	let { items: t, renderItem: n, size: r = de.medium, "aria-label": i, className: o } = e, s = pe[r];
	return /* @__PURE__ */ a("nav", {
		"aria-label": i,
		className: (0, I.default)("tab-bar", `size-${r}`, o),
		children: t.map((e) => {
			let t = (0, I.default)("tab", { "icon-only": e.text === void 0 }), r = me(e, s), i = e.href ?? e.text;
			return !e.disabled && e.href !== void 0 ? n === void 0 ? /* @__PURE__ */ a("a", {
				"aria-current": e.active ? "page" : void 0,
				className: (0, I.default)(t, { "tab-active": e.active }),
				"data-state": e.active ? "active" : "inactive",
				href: e.href,
				children: r
			}, i) : /* @__PURE__ */ a(c, { children: n({
				className: t,
				activeClassName: "tab-active",
				content: r,
				item: e
			}) }, i) : /* @__PURE__ */ a("span", {
				"aria-disabled": "true",
				className: t,
				"data-disabled": "",
				"data-state": "inactive",
				children: r
			}, i);
		})
	});
}, ge = (e, t, n) => {
	let r = t.indexOf(e);
	return r === -1 || t.length === 0 ? null : n === "Home" ? t[0] ?? null : n === "End" ? t[t.length - 1] ?? null : t[(r + (n === "ArrowRight" || n === "ArrowDown" ? 1 : -1) + t.length) % t.length] ?? null;
}, _e = (e) => {
	let { items: t, onValueChange: n, size: r = de.medium, value: i, onKeyDown: o, className: s, ...c } = e, l = pe[r], u = p(() => t.map((e) => ({
		disabled: !!e.disabled,
		value: e.value
	})), [t]), d = u.find((e) => !e.disabled)?.value, [f, m] = h(() => u.find((e) => e.value === i && !e.disabled)?.value ?? d);
	return /* @__PURE__ */ a("div", {
		className: (0, I.default)("tab-bar", `size-${r}`, s),
		role: "group",
		onKeyDown: (e) => {
			if (o?.(e), e.defaultPrevented) return;
			let t = e.target;
			if (!(t instanceof HTMLButtonElement) || t.dataset.tabValue === void 0) return;
			let r = e.key === "ArrowLeft", i = e.key === "ArrowRight", a = e.key === "Home" || e.key === "End";
			if (e.key === "Enter" || e.key === " ") {
				let r = t.dataset.value;
				r !== void 0 && (e.preventDefault(), n(r));
				return;
			}
			if (!r && !i && !a) return;
			let s = ge(t, Array.from(e.currentTarget.querySelectorAll("button[data-tab-value]:not(:disabled)")), e.key);
			s !== null && (e.preventDefault(), s.focus());
		},
		...c,
		children: t.map((e) => {
			let t = e.text === void 0, r = i === e.value, o = f === e.value;
			return /* @__PURE__ */ a("button", {
				"aria-label": e["aria-label"],
				"aria-pressed": r,
				className: (0, I.default)("tab", { "icon-only": t }),
				"data-disabled": e.disabled ? "" : void 0,
				"data-state": r ? "active" : "inactive",
				"data-value": e.value,
				"data-tab-value": e.value,
				disabled: e.disabled,
				tabIndex: o ? 0 : -1,
				type: "button",
				onClick: () => n(e.value),
				onFocus: () => m(e.value),
				children: me(e, l)
			}, e.value);
		})
	});
}, ve = (e) => {
	if (e.nav) return /* @__PURE__ */ a(he, { ...e });
	let { nav: t, ...n } = e;
	return /* @__PURE__ */ a(_e, { ...n });
}, ye = (e) => e ? Array.from(e.querySelectorAll("[role=\"menuitem\"]")) : [], be = (e) => `--menu-${e.replace(/[^a-zA-Z0-9]/g, "")}`, xe = typeof CSS < "u" && typeof CSS.supports == "function" && CSS.supports("anchor-name: --menu"), Se = (e) => {
	let { trigger: t, label: n, triggerLabel: r, children: i, align: s = "start", triggerClassName: c } = e, [l, p] = h(!1), g = m(null), _ = m(null), v = d(), y = be(d());
	return u(() => {
		let e = _.current;
		if (!e) return;
		let t = (e) => {
			p(e.newState === "open");
		};
		return e.addEventListener("toggle", t), () => {
			e.removeEventListener("toggle", t);
		};
	}, []), u(() => {
		if (!l) return;
		let e = ye(_.current), t = e.find((e) => e.getAttribute("aria-current") === "true") ?? e[0];
		t?.focus(), t?.scrollIntoView({ block: "nearest" });
	}, [l]), f(() => {
		if (!l || xe) return;
		let e = _.current, t = g.current;
		if (!e || !t) return;
		let n = () => {
			let n = t.getBoundingClientRect();
			e.style.top = `${n.bottom + 6}px`, s === "end" ? e.style.left = `${n.right - e.offsetWidth}px` : e.style.left = `${n.left}px`;
		};
		return n(), window.addEventListener("scroll", n, !0), window.addEventListener("resize", n), () => {
			window.removeEventListener("scroll", n, !0), window.removeEventListener("resize", n);
		};
	}, [l, s]), /* @__PURE__ */ o("div", {
		className: "menu",
		children: [/* @__PURE__ */ a("button", {
			ref: g,
			type: "button",
			className: (0, I.default)("menu-trigger", c),
			style: { anchorName: y },
			"aria-label": r,
			"aria-haspopup": "menu",
			"aria-expanded": l,
			"aria-controls": v,
			popoverTarget: v,
			children: t(l)
		}), /* @__PURE__ */ a("div", {
			ref: _,
			id: v,
			popover: "auto",
			role: "menu",
			tabIndex: -1,
			"aria-label": n,
			className: (0, I.default)("menu-popup", `menu-popup--${s}`),
			style: { positionAnchor: y },
			onClick: () => _.current?.hidePopover(),
			onKeyDown: (e) => {
				let t = ye(_.current);
				if (t.length === 0) return;
				let n = t.indexOf(document.activeElement);
				e.key === "ArrowDown" ? (e.preventDefault(), t[n < 0 ? 0 : (n + 1) % t.length]?.focus()) : e.key === "ArrowUp" ? (e.preventDefault(), t[n < 0 ? t.length - 1 : (n - 1 + t.length) % t.length]?.focus()) : e.key === "Home" ? (e.preventDefault(), t[0]?.focus()) : e.key === "End" && (e.preventDefault(), t[t.length - 1]?.focus());
			},
			children: /* @__PURE__ */ a("div", {
				className: "menu-scroll",
				role: "none",
				children: i
			})
		})]
	});
}, L = {
	ARROWS_ARROW_RIGHT: "arrows.arrow-right",
	ARROWS_CHEVRON_DOWN: "arrows.chevron-down",
	ARROWS_TRENDING_UP: "arrows.trending-up",
	CLOUD_AND_WEB_TWO_COLUMNS: "cloud-and-web.two-columns",
	FILE_AND_FOLDER_ADD_DOCUMENT: "file-and-folder.add-document",
	FILE_AND_FOLDER_ADD_FILE: "file-and-folder.add-file",
	FILE_AND_FOLDER_ADD_FOLDER: "file-and-folder.add-folder",
	FILE_AND_FOLDER_ARCHIVE: "file-and-folder.archive",
	FILE_AND_FOLDER_DOCUMENT: "file-and-folder.document",
	FILE_AND_FOLDER_RESTORE: "file-and-folder.restore",
	MEDICAL_ADD_BOOK: "medical.add-book",
	MEDICAL_AMBULANCE: "medical.ambulance",
	MEDICAL_STETHOSCOPE: "medical.stethoscope",
	SECURITY_LOCK: "security.lock",
	SECURITY_SHIELD: "security.shield",
	SIGN_AND_SYMBOL_BLOCK: "sign-and-symbol.block",
	USER_INTERFACE_CHECKMARK_CIRCLE: "user-interface.checkmark-circle",
	USER_INTERFACE_CHECKMARK: "user-interface.checkmark",
	USER_INTERFACE_CLOSE_BOLD: "user-interface.close-bold",
	USER_INTERFACE_CLOSE: "user-interface.close",
	USER_INTERFACE_DISLIKE: "user-interface.dislike",
	USER_INTERFACE_EXCLAMATION_MARK_CIRCLE: "user-interface.exclamation-mark-circle",
	USER_INTERFACE_EXCLAMATION_MARK_TRIANGLE: "user-interface.exclamation-mark-triangle",
	USER_INTERFACE_HOUSE: "user-interface.house",
	USER_INTERFACE_LIKE: "user-interface.like",
	USER_INTERFACE_MAGNIFIER: "user-interface.magnifier",
	USER_INTERFACE_MOVE: "user-interface.move",
	USER_INTERFACE_PAPER_PLANE: "user-interface.paper-plane",
	USER_INTERFACE_PEN: "user-interface.pen",
	USER_INTERFACE_SETTING: "user-interface.setting"
}, Ce = {
	text: "text",
	check: "check"
}, we = (e) => {
	let { children: t, selected: n = !1, selectedIndicator: r = Ce.text, description: s } = e, c = r === Ce.check, l = s !== void 0, u = (0, I.default)("menu-item", {
		"menu-item--selected": n,
		"menu-item--detailed": l,
		"menu-item--check": c
	}), d = /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ o("span", {
		className: "menu-item-body",
		children: [/* @__PURE__ */ a("span", {
			className: "menu-item-title",
			children: t
		}), l ? /* @__PURE__ */ a("span", {
			className: "menu-item-description",
			children: s
		}) : null]
	}), n && c ? /* @__PURE__ */ a(k, {
		name: L.USER_INTERFACE_CHECKMARK,
		size: 12,
		ariaLabel: "Selected"
	}) : null] }), f = n ? "true" : void 0;
	if (typeof e.to == "string") {
		let t = {
			className: u,
			role: "menuitem",
			"aria-current": f,
			children: d
		};
		return e.renderItem === void 0 ? /* @__PURE__ */ a("a", {
			...t,
			href: e.to
		}) : e.renderItem(t);
	}
	return /* @__PURE__ */ a("button", {
		type: "button",
		role: "menuitem",
		className: u,
		"aria-current": f,
		onClick: e.onSelect,
		children: d
	});
}, Te = (e) => {
	let t = e.trim();
	if (t === "") return "";
	let n = t.indexOf(","), r = (n === -1 ? t : `${t.slice(n + 1).trim()} ${t.slice(0, n).trim()}`.trim()).split(/\s+/).filter(Boolean);
	if (r.length === 0) return "";
	let i = r[0].endsWith(".") && r.length > 1 ? r.slice(1) : r, a = i.length >= 2 ? i : r;
	return (a.length >= 2 ? a[0][0] + a[a.length - 1][0] : a[0].slice(0, 2)).toUpperCase();
}, Ee = {
	small: "small",
	medium: "medium",
	large: "large"
}, De = {
	violet: "violet",
	blue: "blue",
	lilac: "lilac",
	yellow: "yellow",
	red: "red",
	green: "green",
	grey: "grey"
}, Oe = (e) => {
	let { name: t, size: n = Ee.medium, color: r = De.violet, className: i, ...o } = e, s = Te(t), c = t.trim() !== "";
	return /* @__PURE__ */ a("span", {
		className: [
			"avatar",
			`avatar-size-${n}`,
			`avatar-color-${r}`,
			i
		].filter(Boolean).join(" "),
		role: "img",
		"aria-label": c ? t : void 0,
		...o,
		children: /* @__PURE__ */ a("span", {
			className: "avatar-initials",
			"aria-hidden": "true",
			children: s
		})
	});
}, ke = ({ value: e, onChange: t, onClear: n, label: r, placeholderText: i, disabled: s, ...c }) => {
	let l = d(), u = m(null), f = e.length > 0, p = (e) => {
		t(e.target.value);
	}, h = () => {
		n(), u.current?.focus();
	};
	return /* @__PURE__ */ o("div", {
		className: "search-input-field",
		children: [
			/* @__PURE__ */ a("label", {
				className: "search-input-icon",
				htmlFor: l,
				children: /* @__PURE__ */ a(k, {
					color: "grey",
					name: L.USER_INTERFACE_MAGNIFIER,
					size: 18
				})
			}),
			/* @__PURE__ */ a("input", {
				...c,
				"aria-label": r,
				className: "search-input-control",
				disabled: s,
				id: l,
				onChange: p,
				placeholder: i,
				ref: u,
				type: "search",
				value: e
			}),
			f ? /* @__PURE__ */ a("button", {
				"aria-label": "Clear search",
				className: "search-input-clear",
				disabled: s,
				onClick: h,
				type: "button",
				children: /* @__PURE__ */ a(k, {
					color: "grey",
					name: L.USER_INTERFACE_CLOSE,
					size: 16
				})
			}) : null
		]
	});
}, R = {
	default: "default",
	error: "error",
	disabled: "disabled",
	readOnly: "readOnly"
}, Ae = {
	standard: "standard",
	small: "small",
	mini: "mini"
}, je = {
	singleline: 558,
	multiline: 542,
	mini: 400
}, Me = (e) => ({
	disabled: e === R.disabled,
	readOnly: e === R.readOnly,
	ariaInvalid: e === R.error || void 0
}), Ne = ({ multiline: e, size: t }) => e ? je.multiline : t === Ae.mini ? je.mini : je.singleline, Pe = ({ state: e, showHelperText: t, helperText: n, errorMessage: r }) => e === R.error && r ? {
	text: r,
	icon: L.USER_INTERFACE_EXCLAMATION_MARK_TRIANGLE,
	isError: !0
} : t && n ? {
	text: n,
	icon: L.USER_INTERFACE_EXCLAMATION_MARK_CIRCLE,
	isError: !1
} : null, Fe = ({ state: e = R.default, size: t = Ae.standard, showLabel: n = !1, label: r, placeholderText: i, showHelperText: s = !1, helperText: c, errorMessage: l, maxWidth: u, containerStyle: f, multiline: p = !1, ...m }) => {
	let h = d(), g = Pe({
		state: e,
		showHelperText: s,
		helperText: c,
		errorMessage: l
	}), _ = g ? `${h}-helper` : void 0, v = [m["aria-describedby"], _].filter(Boolean).join(" "), { disabled: y, readOnly: b, ariaInvalid: x } = Me(e), S = u ?? Ne({
		multiline: p,
		size: t
	}), C = t !== Ae.mini && n && !!r, w = [
		"text-input-root",
		`state-${e}`,
		`size-${t}`,
		...p ? ["multiline"] : ["singleline"]
	].join(" "), T = [
		"text-input-field",
		`state-${e}`,
		`size-${t}`
	].join(" "), E = g ? ["text-input-helper", g.isError ? "text-input-helper-error" : "text-input-helper-default"].join(" ") : void 0;
	return /* @__PURE__ */ o("div", {
		className: w,
		"data-state": e,
		style: {
			maxWidth: S,
			...f
		},
		children: [
			C ? /* @__PURE__ */ a("label", {
				className: "text-input-label",
				htmlFor: h,
				children: r
			}) : null,
			a(p ? "textarea" : "input", {
				...m,
				"aria-describedby": v || void 0,
				"aria-invalid": x,
				className: T,
				disabled: y,
				id: h,
				placeholder: i,
				readOnly: b
			}),
			g ? /* @__PURE__ */ o("div", {
				className: E,
				id: _,
				children: [/* @__PURE__ */ a(k, {
					name: g.icon,
					size: 16
				}), /* @__PURE__ */ a("span", { children: g.text })]
			}) : null
		]
	});
};
//#endregion
//#region node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Ie() {
	return typeof window < "u";
}
function z(e) {
	return Le(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function B(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function V(e) {
	return ((Le(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Le(e) {
	return Ie() ? e instanceof Node || e instanceof B(e).Node : !1;
}
function H(e) {
	return Ie() ? e instanceof Element || e instanceof B(e).Element : !1;
}
function U(e) {
	return Ie() ? e instanceof HTMLElement || e instanceof B(e).HTMLElement : !1;
}
function Re(e) {
	return !Ie() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof B(e).ShadowRoot;
}
function ze(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = G(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function Be(e) {
	return /^(table|td|th)$/.test(z(e));
}
function Ve(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var He = /transform|translate|scale|rotate|perspective|filter/, Ue = /paint|layout|strict|content/, W = (e) => !!e && e !== "none", We;
function Ge(e) {
	let t = H(e) ? G(e) : e;
	return W(t.transform) || W(t.translate) || W(t.scale) || W(t.rotate) || W(t.perspective) || !qe() && (W(t.backdropFilter) || W(t.filter)) || He.test(t.willChange || "") || Ue.test(t.contain || "");
}
function Ke(e) {
	let t = K(e);
	for (; U(t) && !Je(t);) {
		if (Ge(t)) return t;
		if (Ve(t)) return null;
		t = K(t);
	}
	return null;
}
function qe() {
	return We ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), We;
}
function Je(e) {
	return /^(html|body|#document)$/.test(z(e));
}
function G(e) {
	return B(e).getComputedStyle(e);
}
function Ye(e) {
	return H(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function K(e) {
	if (z(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Re(e) && e.host || V(e);
	return Re(t) ? t.host : t;
}
function Xe(e) {
	let t = K(e);
	return Je(t) ? (e.ownerDocument || e).body : U(t) && ze(t) ? t : Xe(t);
}
function Ze(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Xe(e), i = r === e.ownerDocument?.body, a = B(r);
	if (i) {
		let e = Qe(a);
		return t.concat(a, a.visualViewport || [], ze(r) ? r : [], e && n ? Ze(e) : []);
	} else return t.concat(r, Ze(r, [], n));
}
function Qe(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var $e = Math.min, q = Math.max, et = Math.round, tt = Math.floor, J = (e) => ({
	x: e,
	y: e
}), nt = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function rt(e, t, n) {
	return q(e, $e(t, n));
}
function it(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function at(e) {
	return e.split("-")[0];
}
function ot(e) {
	return e.split("-")[1];
}
function st(e) {
	return e === "x" ? "y" : "x";
}
function ct(e) {
	return e === "y" ? "height" : "width";
}
function Y(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function lt(e) {
	return st(Y(e));
}
function ut(e, t, n) {
	n === void 0 && (n = !1);
	let r = ot(e), i = lt(e), a = ct(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = yt(o)), [o, yt(o)];
}
function dt(e) {
	let t = yt(e);
	return [
		ft(e),
		t,
		ft(t)
	];
}
function ft(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var pt = ["left", "right"], mt = ["right", "left"], ht = ["top", "bottom"], gt = ["bottom", "top"];
function _t(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? mt : pt : t ? pt : mt;
		case "left":
		case "right": return t ? ht : gt;
		default: return [];
	}
}
function vt(e, t, n, r) {
	let i = ot(e), a = _t(at(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(ft)))), a;
}
function yt(e) {
	let t = at(e);
	return nt[t] + e.slice(t.length);
}
function bt(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function xt(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : bt(e);
}
function St(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
var Ct = /* #__PURE__ */ [
	"input:not([inert]):not([inert] *)",
	"select:not([inert]):not([inert] *)",
	"textarea:not([inert]):not([inert] *)",
	"a[href]:not([inert]):not([inert] *)",
	"area[href]:not([inert]):not([inert] *)",
	"button:not([inert]):not([inert] *)",
	"[tabindex]:not(slot):not([inert]):not([inert] *)",
	"audio[controls]:not([inert]):not([inert] *)",
	"video[controls]:not([inert]):not([inert] *)",
	"[contenteditable]:not([contenteditable=\"false\"]):not([inert]):not([inert] *)",
	"details>summary:first-of-type:not([inert]):not([inert] *)",
	"details:not([inert]):not([inert] *)"
].join(","), wt = typeof Element > "u", Tt = wt ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Et = !wt && Element.prototype.getRootNode ? function(e) {
	return e?.getRootNode?.call(e);
} : function(e) {
	return e?.ownerDocument;
}, Dt = function(e, t) {
	t === void 0 && (t = !0);
	var n = e?.getAttribute?.call(e, "inert");
	return n === "" || n === "true" || t && e && (typeof e.closest == "function" ? e.closest("[inert]") : Dt(e.parentNode));
}, Ot = function(e) {
	var t = e?.getAttribute?.call(e, "contenteditable");
	return t === "" || t === "true";
}, kt = function(e, t, n) {
	if (Dt(e)) return [];
	var r = Array.prototype.slice.apply(e.querySelectorAll(Ct));
	return t && Tt.call(e, Ct) && r.unshift(e), r = r.filter(n), r;
}, At = function(e, t, n) {
	for (var r = [], i = Array.from(e); i.length;) {
		var a = i.shift();
		if (!Dt(a, !1)) if (a.tagName === "SLOT") {
			var o = a.assignedElements(), s = At(o.length ? o : a.children, !0, n);
			n.flatten ? r.push.apply(r, s) : r.push({
				scopeParent: a,
				candidates: s
			});
		} else {
			Tt.call(a, Ct) && n.filter(a) && (t || !e.includes(a)) && r.push(a);
			var c = a.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(a), l = !Dt(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
			if (c && l) {
				var u = At(c === !0 ? a.children : c.children, !0, n);
				n.flatten ? r.push.apply(r, u) : r.push({
					scopeParent: a,
					candidates: u
				});
			} else i.unshift.apply(i, a.children);
		}
	}
	return r;
}, jt = function(e) {
	return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, Mt = function(e) {
	if (!e) throw Error("No node provided");
	return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || Ot(e)) && !jt(e) ? 0 : e.tabIndex;
}, Nt = function(e, t) {
	var n = Mt(e);
	return n < 0 && t && !jt(e) ? 0 : n;
}, Pt = function(e, t) {
	return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, Ft = function(e) {
	return e.tagName === "INPUT";
}, It = function(e) {
	return Ft(e) && e.type === "hidden";
}, Lt = function(e) {
	return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(e) {
		return e.tagName === "SUMMARY";
	});
}, Rt = function(e, t) {
	for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
}, zt = function(e) {
	if (!e.name) return !0;
	var t = e.form || Et(e), n = function(e) {
		return t.querySelectorAll("input[type=\"radio\"][name=\"" + e + "\"]");
	}, r;
	if (typeof window < "u" && window.CSS !== void 0 && typeof window.CSS.escape == "function") r = n(window.CSS.escape(e.name));
	else try {
		r = n(e.name);
	} catch (e) {
		return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
	}
	var i = Rt(r, e.form);
	return !i || i === e;
}, Bt = function(e) {
	return Ft(e) && e.type === "radio";
}, Vt = function(e) {
	return Bt(e) && !zt(e);
}, Ht = function(e) {
	var t = e && Et(e), n = t?.host, r = !1;
	if (t && t !== e) {
		var i, a, o;
		for (r = !!((i = n) != null && (a = i.ownerDocument) != null && a.contains(n) || e != null && (o = e.ownerDocument) != null && o.contains(e)); !r && n;) {
			var s, c;
			t = Et(n), n = t?.host, r = !!((s = n) != null && (c = s.ownerDocument) != null && c.contains(n));
		}
	}
	return r;
}, Ut = function(e) {
	var t = e.getBoundingClientRect(), n = t.width, r = t.height;
	return n === 0 && r === 0;
}, Wt = function(e, t) {
	var n = t.displayCheck, r = t.getShadowRoot;
	if (n === "full-native" && "checkVisibility" in e) return !e.checkVisibility({
		checkOpacity: !1,
		opacityProperty: !1,
		contentVisibilityAuto: !0,
		visibilityProperty: !0,
		checkVisibilityCSS: !0
	});
	var i = getComputedStyle(e).visibility;
	if (i === "hidden" || i === "collapse") return !0;
	var a = Tt.call(e, "details>summary:first-of-type") ? e.parentElement : e;
	if (Tt.call(a, "details:not([open]) *")) return !0;
	if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
		if (typeof r == "function") {
			for (var o = e; e;) {
				var s = e.parentElement, c = Et(e);
				if (s && !s.shadowRoot && r(s) === !0) return Ut(e);
				e = e.assignedSlot ? e.assignedSlot : !s && c !== e.ownerDocument ? c.host : s;
			}
			e = o;
		}
		if (Ht(e)) return !e.getClientRects().length;
		if (n !== "legacy-full") return !0;
	} else if (n === "non-zero-area") return Ut(e);
	return !1;
}, Gt = function(e) {
	if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
		if (t.tagName === "FIELDSET" && t.disabled) {
			for (var n = 0; n < t.children.length; n++) {
				var r = t.children.item(n);
				if (r.tagName === "LEGEND") return Tt.call(t, "fieldset[disabled] *") ? !0 : !r.contains(e);
			}
			return !0;
		}
		t = t.parentElement;
	}
	return !1;
}, Kt = function(e, t) {
	return !(t.disabled || It(t) || Wt(t, e) || Lt(t) || Gt(t));
}, qt = function(e, t) {
	return !(Vt(t) || Mt(t) < 0 || !Kt(e, t));
}, Jt = function(e) {
	var t = parseInt(e.getAttribute("tabindex"), 10);
	return !!(isNaN(t) || t >= 0);
}, Yt = function(e) {
	var t = [], n = [];
	return e.forEach(function(e, r) {
		var i = !!e.scopeParent, a = i ? e.scopeParent : e, o = Nt(a, i), s = i ? Yt(e.candidates) : a;
		o === 0 ? i ? t.push.apply(t, s) : t.push(a) : n.push({
			documentOrder: r,
			tabIndex: o,
			item: e,
			isScope: i,
			content: s
		});
	}), n.sort(Pt).reduce(function(e, t) {
		return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
	}, []).concat(t);
}, Xt = function(e, t) {
	return t ||= {}, Yt(t.getShadowRoot ? At([e], t.includeContainer, {
		filter: qt.bind(null, t),
		flatten: !1,
		getShadowRoot: t.getShadowRoot,
		shadowRootFilter: Jt
	}) : kt(e, t.includeContainer, qt.bind(null, t)));
};
//#endregion
//#region node_modules/.pnpm/@floating-ui+react@0.27.20_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs
function Zt() {
	let e = navigator.userAgentData;
	return e != null && e.platform ? e.platform : navigator.platform;
}
function Qt() {
	let e = navigator.userAgentData;
	return e && Array.isArray(e.brands) ? e.brands.map((e) => {
		let { brand: t, version: n } = e;
		return t + "/" + n;
	}).join(" ") : navigator.userAgent;
}
function $t() {
	return /apple/i.test(navigator.vendor);
}
function en() {
	return Zt().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function tn() {
	return Qt().includes("jsdom/");
}
var nn = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function rn(e) {
	let t = e.activeElement;
	for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null;) {
		var n;
		t = t.shadowRoot.activeElement;
	}
	return t;
}
function an(e, t) {
	if (!e || !t) return !1;
	let n = t.getRootNode == null ? void 0 : t.getRootNode();
	if (e.contains(t)) return !0;
	if (n && Re(n)) {
		let n = t;
		for (; n;) {
			if (e === n) return !0;
			n = n.parentNode || n.host;
		}
	}
	return !1;
}
function on(e) {
	return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function X(e) {
	return e?.ownerDocument || document;
}
function sn(e) {
	return U(e) && e.matches(nn);
}
function cn(e) {
	if (!e || tn()) return !0;
	try {
		return e.matches(":focus-visible");
	} catch {
		return !0;
	}
}
function ln(e, t) {
	let n = ["mouse", "pen"];
	return t || n.push("", void 0), n.includes(e);
}
var Z = typeof document < "u" ? f : function() {}, un = { ...s };
function dn(e) {
	let t = s.useRef(e);
	return Z(() => {
		t.current = e;
	}), t;
}
var fn = un.useInsertionEffect || ((e) => e());
function pn(e) {
	let t = s.useRef(() => {
		if (process.env.NODE_ENV !== "production") throw Error("Cannot call an event handler while rendering.");
	});
	return fn(() => {
		t.current = e;
	}), s.useCallback(function() {
		var e = [...arguments];
		return t.current == null ? void 0 : t.current(...e);
	}, []);
}
var mn = () => ({
	getShadowRoot: !0,
	displayCheck: typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
});
function hn(e, t) {
	let n = Xt(e, mn()), r = n.length;
	if (r === 0) return;
	let i = rn(X(e)), a = n.indexOf(i);
	return n[a === -1 ? t === 1 ? 0 : r - 1 : a + t];
}
function gn(e) {
	return hn(X(e).body, 1) || e;
}
function _n(e) {
	return hn(X(e).body, -1) || e;
}
function vn(e, t) {
	let n = t || e.currentTarget, r = e.relatedTarget;
	return !r || !an(n, r);
}
function yn(e) {
	Xt(e, mn()).forEach((e) => {
		e.dataset.tabindex = e.getAttribute("tabindex") || "", e.setAttribute("tabindex", "-1");
	});
}
function bn(e) {
	e.querySelectorAll("[data-tabindex]").forEach((e) => {
		let t = e.dataset.tabindex;
		delete e.dataset.tabindex, t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
	});
}
//#endregion
//#region node_modules/.pnpm/@floating-ui+core@1.8.0/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function xn(e, t, n) {
	let { reference: r, floating: i } = e, a = Y(t), o = lt(t), s = ct(o), c = at(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = ot(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function Sn(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = it(t, e), p = xt(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = St(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = St(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Cn = 50, wn = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: Sn
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = xn(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < Cn && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = xn(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, Tn = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = it(e, t) || {};
		if (l == null) return {};
		let d = xt(u), f = {
			x: n,
			y: r
		}, p = lt(i), m = ct(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = $e(d[_], T), D = $e(d[v], T), O = C - h[m] - D, k = C / 2 - h[m] / 2 + w, A = rt(E, k, O), j = !c.arrow && ot(i) != null && k !== A && a.reference[m] / 2 - (k < E ? E : D) - h[m] / 2 < 0, M = j ? k < E ? k - E : k - O : 0;
		return {
			[p]: f[p] + M,
			data: {
				[p]: A,
				centerOffset: k - A - M,
				...j && { alignmentOffset: M }
			},
			reset: j
		};
	}
}), En = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = it(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = at(r), _ = Y(o), v = at(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [yt(o)] : dt(o)), x = p !== "none";
			!d && x && b.push(...vt(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = ut(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (!(u === "alignment" && _ !== Y(t)) || T.every((e) => Y(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = Y(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement":
						n = o;
						break;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
}, Dn = /*#__PURE__*/ new Set(["left", "top"]);
async function On(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = at(n), s = ot(n), c = Y(n) === "y", l = Dn.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = it(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var kn = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await On(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, An = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = it(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = Y(i), p = st(f), m = u[p], h = u[f], g = (e, t) => rt(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
};
//#endregion
//#region node_modules/.pnpm/@floating-ui+dom@1.8.0/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function jn(e) {
	let t = G(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = U(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = et(n) !== a || et(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Mn(e) {
	return H(e) ? e : e.contextElement;
}
function Nn(e) {
	let t = Mn(e);
	if (!U(t)) return J(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = jn(t), o = (a ? et(n.width) : n.width) / r, s = (a ? et(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var Pn = /*#__PURE__*/ J(0);
function Fn(e) {
	let t = B(e);
	return !qe() || !t.visualViewport ? Pn : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function In(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === B(e);
}
function Q(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Mn(e), o = J(1);
	t && (r ? H(r) && (o = Nn(r)) : o = Nn(e));
	let s = In(a, n, r) ? Fn(a) : J(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = B(a), t = H(r) ? B(r) : r, n = e, i = Qe(n);
		for (; i && t !== n;) {
			let e = Nn(i), t = i.getBoundingClientRect(), r = G(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = B(i), i = Qe(n);
		}
	}
	return St({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function Ln(e, t) {
	let n = Ye(e).scrollLeft;
	return t ? t.left + n : Q(V(e)).left + n;
}
function Rn(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - Ln(e, n),
		y: n.top + t.scrollTop
	};
}
function zn(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = V(r), s = t ? Ve(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = J(1), u = J(0), d = U(r);
	if ((d || !a) && ((z(r) !== "body" || ze(o)) && (c = Ye(r)), d)) {
		let e = Q(r);
		l = Nn(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? Rn(o, c) : J(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function Bn(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Vn(e) {
	let t = Ye(e), n = e.ownerDocument.body, r = q(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = q(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + Ln(e), o = -t.scrollTop;
	return G(n).direction === "rtl" && (a += q(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var Hn = 25;
function Un(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = B(e), a = V(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !qe() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (Ln(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= Hn && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function Wn(e, t) {
	let n = Q(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Nn(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Gn(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = Un(e, n, t);
	else if (t === "document") r = Vn(V(e));
	else if (H(t)) r = Wn(t, n);
	else {
		let n = Fn(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return St(r);
}
function Kn(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Ze(e, [], !1).filter((e) => H(e) && z(e) !== "body"), i = null, a = G(e).position === "fixed", o = a ? K(e) : e;
	for (; H(o) && !Je(o);) {
		let e = G(o), t = Ge(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = K(o);
	}
	return t.set(e, r), r;
}
function qn(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Ve(t) ? [] : Kn(t, this._c) : [].concat(n), r], o = Gn(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = Gn(t, a[e], i);
		s = q(n.top, s), c = $e(n.right, c), l = $e(n.bottom, l), u = q(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function Jn(e) {
	let { width: t, height: n } = jn(e);
	return {
		width: t,
		height: n
	};
}
function Yn(e, t, n) {
	let r = U(t), i = V(t), a = n === "fixed", o = Q(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = J(0);
	if ((r || !a) && ((z(t) !== "body" || ze(i)) && (s = Ye(t)), r)) {
		let e = Q(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = Ln(i));
	let l = i && !r && !a ? Rn(i, s) : J(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function Xn(e) {
	return G(e).position === "static";
}
function Zn(e, t) {
	if (!U(e) || G(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return V(e) === n && (n = n.ownerDocument.body), n;
}
function Qn(e, t) {
	let n = B(e);
	if (Ve(e)) return n;
	if (!U(e)) {
		let t = K(e);
		for (; t && !Je(t);) {
			if (H(t) && !Xn(t)) return t;
			t = K(t);
		}
		return n;
	}
	let r = Zn(e, t);
	for (; r && Be(r) && Xn(r);) r = Zn(r, t);
	return r && Je(r) && Xn(r) && !Ge(r) ? n : r || Ke(e) || n;
}
var $n = async function(e) {
	let t = this.getOffsetParent || Qn, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: Yn(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function er(e) {
	return G(e).direction === "rtl";
}
var tr = {
	convertOffsetParentRelativeRectToViewportRelativeRect: zn,
	getDocumentElement: V,
	getClippingRect: qn,
	getOffsetParent: Qn,
	getElementRects: $n,
	getClientRects: Bn,
	getDimensions: Jn,
	getScale: Nn,
	isElement: H,
	isRTL: er
};
function nr(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function rr(e, t, n) {
	let r = null, i, a = V(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = tt(d), h = tt(a.clientWidth - (u + f)), g = tt(a.clientHeight - (d + p)), _ = tt(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: q(0, $e(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!nr(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = B(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function ir(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Mn(e), u = i || a ? [...l ? Ze(l) : [], ...t ? Ze(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? rr(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? Q(e) : null;
	c && g();
	function g() {
		let t = Q(e);
		h && !nr(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var ar = kn, or = An, sr = En, cr = Tn, lr = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...tr,
		...i.platform,
		_c: r
	};
	return wn(e, t, {
		...i,
		platform: a
	});
}, ur = typeof document < "u" ? f : function() {};
function dr(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!dr(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !dr(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function fr(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pr(e, t) {
	let n = fr(e);
	return Math.round(t * n) / n;
}
function mr(e) {
	let t = s.useRef(e);
	return ur(() => {
		t.current = e;
	}), t;
}
function hr(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: c = !0, whileElementsMounted: l, open: u } = e, [d, f] = s.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [p, m] = s.useState(r);
	dr(p, r) || m(r);
	let [h, _] = s.useState(null), [v, y] = s.useState(null), b = s.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), x = s.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = a || h, C = o || v, w = s.useRef(null), T = s.useRef(null), E = s.useRef(d), D = l != null, O = mr(l), k = mr(i), A = mr(u), j = s.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: p
		};
		k.current && (e.platform = k.current), lr(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !dr(E.current, t) && (E.current = t, g.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		t,
		n,
		k,
		A
	]);
	ur(() => {
		u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let M = s.useRef(!1);
	ur(() => (M.current = !0, () => {
		M.current = !1;
	}), []), ur(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (O.current) return O.current(S, C, j);
			j();
		}
	}, [
		S,
		C,
		j,
		O,
		D
	]);
	let N = s.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), P = s.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), F = s.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!P.floating) return e;
		let t = pr(P.floating, d.x), r = pr(P.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...fr(P.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		c,
		P.floating,
		d.x,
		d.y
	]);
	return s.useMemo(() => ({
		...d,
		update: j,
		refs: N,
		elements: P,
		floatingStyles: F
	}), [
		d,
		j,
		N,
		P,
		F
	]);
}
var gr = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : cr({
				element: r.current,
				padding: i
			}).fn(n) : r ? cr({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, _r = (e, t) => {
	let n = ar(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, vr = (e, t) => {
	let n = or(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, yr = (e, t) => {
	let n = sr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, br = (e, t) => {
	let n = gr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, xr = "data-floating-ui-focusable", Sr = "active", Cr = "selected", wr = "ArrowLeft", Tr = "ArrowRight", Er = "ArrowUp", Dr = "ArrowDown", Or = [wr, Tr], kr = [Er, Dr];
[...Or, ...kr];
var Ar = { ...s }, jr = !1, Mr = 0, Nr = () => "floating-ui-" + Math.random().toString(36).slice(2, 6) + Mr++;
function Pr() {
	let [e, t] = s.useState(() => jr ? Nr() : void 0);
	return Z(() => {
		e ?? t(Nr());
	}, []), s.useEffect(() => {
		jr = !0;
	}, []), e;
}
var Fr = Ar.useId || Pr, Ir;
process.env.NODE_ENV !== "production" && (Ir = /*#__PURE__*/ new Set());
function Lr() {
	var e;
	let t = "Floating UI: " + [...arguments].join(" ");
	if (!((e = Ir) != null && e.has(t))) {
		var n;
		(n = Ir) == null || n.add(t), console.warn(t);
	}
}
function Rr() {
	var e;
	let t = "Floating UI: " + [...arguments].join(" ");
	if (!((e = Ir) != null && e.has(t))) {
		var n;
		(n = Ir) == null || n.add(t), console.error(t);
	}
}
var zr = /*#__PURE__*/ s.forwardRef(function(e, t) {
	let { context: { placement: n, elements: { floating: r }, middlewareData: { arrow: i, shift: c } }, width: l = 14, height: u = 7, tipRadius: d = 0, strokeWidth: f = 0, staticOffset: p, stroke: m, d: h, style: { transform: g, ..._ } = {}, ...v } = e;
	process.env.NODE_ENV !== "production" && (t || Lr("The `ref` prop is required for `FloatingArrow`."));
	let y = Fr(), [b, x] = s.useState(!1);
	if (Z(() => {
		r && G(r).direction === "rtl" && x(!0);
	}, [r]), !r) return null;
	let [S, C] = n.split("-"), w = S === "top" || S === "bottom", T = p;
	(w && c != null && c.x || !w && c != null && c.y) && (T = null);
	let E = f * 2, D = E / 2, O = l / 2 * (d / -8 + 1), k = u / 2 * d / 4, A = !!h, j = T && C === "end" ? "bottom" : "top", M = T && C === "end" ? "right" : "left";
	T && b && (M = C === "end" ? "left" : "right");
	let N = i?.x == null ? "" : T || i.x, P = i?.y == null ? "" : T || i.y, F = h || "M0,0" + (" H" + l) + (" L" + (l - O) + "," + (u - k)) + (" Q" + l / 2 + "," + u + " " + O + "," + (u - k)) + " Z", ee = {
		top: A ? "rotate(180deg)" : "",
		left: A ? "rotate(90deg)" : "rotate(-90deg)",
		bottom: A ? "" : "rotate(180deg)",
		right: A ? "rotate(-90deg)" : "rotate(90deg)"
	}[S];
	return /*#__PURE__*/ o("svg", {
		...v,
		"aria-hidden": !0,
		ref: t,
		width: A ? l : l + E,
		height: l,
		viewBox: "0 0 " + l + " " + (u > l ? u : l),
		style: {
			position: "absolute",
			pointerEvents: "none",
			[M]: N,
			[j]: P,
			[S]: w || A ? "100%" : "calc(100% - " + E / 2 + "px)",
			transform: [ee, g].filter((e) => !!e).join(" "),
			..._
		},
		children: [
			E > 0 && /*#__PURE__*/ a("path", {
				clipPath: "url(#" + y + ")",
				fill: "none",
				stroke: m,
				strokeWidth: E + +!h,
				d: F
			}),
			/*#__PURE__*/ a("path", {
				stroke: E && !h ? v.fill : "none",
				d: F
			}),
			/*#__PURE__*/ a("clipPath", {
				id: y,
				children: /*#__PURE__*/ a("rect", {
					x: -D,
					y: D * (A ? -1 : 1),
					width: l + E,
					height: l
				})
			})
		]
	});
});
function Br() {
	let e = /* @__PURE__ */ new Map();
	return {
		emit(t, n) {
			var r;
			(r = e.get(t)) == null || r.forEach((e) => e(n));
		},
		on(t, n) {
			e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
		},
		off(t, n) {
			var r;
			(r = e.get(t)) == null || r.delete(n);
		}
	};
}
var Vr = /*#__PURE__*/ s.createContext(null), Hr = /*#__PURE__*/ s.createContext(null), Ur = () => s.useContext(Vr)?.id || null, Wr = () => s.useContext(Hr);
function Gr(e) {
	return "data-floating-ui-" + e;
}
function $(e) {
	e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
var Kr = /*#__PURE__*/ Gr("safe-polygon");
function qr(e, t, n) {
	if (n && !ln(n)) return 0;
	if (typeof e == "number") return e;
	if (typeof e == "function") {
		let n = e();
		return typeof n == "number" ? n : n?.[t];
	}
	return e?.[t];
}
function Jr(e) {
	return typeof e == "function" ? e() : e;
}
function Yr(e, t) {
	t === void 0 && (t = {});
	let { open: n, onOpenChange: r, dataRef: i, events: a, elements: o } = e, { enabled: c = !0, delay: l = 0, handleClose: u = null, mouseOnly: d = !1, restMs: f = 0, move: p = !0 } = t, m = Wr(), h = Ur(), g = dn(u), _ = dn(l), v = dn(n), y = dn(f), b = s.useRef(), x = s.useRef(-1), S = s.useRef(), C = s.useRef(-1), w = s.useRef(!0), T = s.useRef(!1), E = s.useRef(() => {}), D = s.useRef(!1), O = pn(() => {
		let e = i.current.openEvent?.type;
		return e?.includes("mouse") && e !== "mousedown";
	});
	s.useEffect(() => {
		if (!c) return;
		function e(e) {
			let { open: t } = e;
			t || ($(x), $(C), w.current = !0, D.current = !1);
		}
		return a.on("openchange", e), () => {
			a.off("openchange", e);
		};
	}, [c, a]), s.useEffect(() => {
		if (!c || !g.current || !n) return;
		function e(e) {
			O() && r(!1, e, "hover");
		}
		let t = X(o.floating).documentElement;
		return t.addEventListener("mouseleave", e), () => {
			t.removeEventListener("mouseleave", e);
		};
	}, [
		o.floating,
		n,
		r,
		c,
		g,
		O
	]);
	let k = s.useCallback(function(e, t, n) {
		t === void 0 && (t = !0), n === void 0 && (n = "hover");
		let i = qr(_.current, "close", b.current);
		i && !S.current ? ($(x), x.current = window.setTimeout(() => r(!1, e, n), i)) : t && ($(x), r(!1, e, n));
	}, [_, r]), A = pn(() => {
		E.current(), S.current = void 0;
	}), j = pn(() => {
		if (T.current) {
			let e = X(o.floating).body;
			e.style.pointerEvents = "", e.removeAttribute(Kr), T.current = !1;
		}
	}), M = pn(() => i.current.openEvent ? ["click", "mousedown"].includes(i.current.openEvent.type) : !1);
	s.useEffect(() => {
		if (!c) return;
		function e(e) {
			if ($(x), w.current = !1, d && !ln(b.current) || Jr(y.current) > 0 && !qr(_.current, "open")) return;
			let t = qr(_.current, "open", b.current);
			t ? x.current = window.setTimeout(() => {
				v.current || r(!0, e, "hover");
			}, t) : n || r(!0, e, "hover");
		}
		function t(e) {
			if (M()) {
				j();
				return;
			}
			E.current();
			let t = X(o.floating);
			if ($(C), D.current = !1, g.current && i.current.floatingContext) {
				n || $(x), S.current = g.current({
					...i.current.floatingContext,
					tree: m,
					x: e.clientX,
					y: e.clientY,
					onClose() {
						j(), A(), M() || k(e, !0, "safe-polygon");
					}
				});
				let r = S.current;
				t.addEventListener("mousemove", r), E.current = () => {
					t.removeEventListener("mousemove", r);
				};
				return;
			}
			(b.current !== "touch" || !an(o.floating, e.relatedTarget)) && k(e);
		}
		function a(e) {
			M() || i.current.floatingContext && (g.current == null || g.current({
				...i.current.floatingContext,
				tree: m,
				x: e.clientX,
				y: e.clientY,
				onClose() {
					j(), A(), M() || k(e);
				}
			})(e));
		}
		function s() {
			$(x);
		}
		function l(e) {
			M() || k(e, !1);
		}
		if (H(o.domReference)) {
			let r = o.domReference, i = o.floating;
			return n && r.addEventListener("mouseleave", a), p && r.addEventListener("mousemove", e, { once: !0 }), r.addEventListener("mouseenter", e), r.addEventListener("mouseleave", t), i && (i.addEventListener("mouseleave", a), i.addEventListener("mouseenter", s), i.addEventListener("mouseleave", l)), () => {
				n && r.removeEventListener("mouseleave", a), p && r.removeEventListener("mousemove", e), r.removeEventListener("mouseenter", e), r.removeEventListener("mouseleave", t), i && (i.removeEventListener("mouseleave", a), i.removeEventListener("mouseenter", s), i.removeEventListener("mouseleave", l));
			};
		}
	}, [
		o,
		c,
		e,
		d,
		p,
		k,
		A,
		j,
		r,
		n,
		v,
		m,
		_,
		g,
		i,
		M,
		y
	]), Z(() => {
		var e;
		if (c && n && (e = g.current) != null && (e = e.__options) != null && e.blockPointerEvents && O()) {
			T.current = !0;
			let e = o.floating;
			if (H(o.domReference) && e) {
				var t;
				let n = X(o.floating).body;
				n.setAttribute(Kr, "");
				let r = o.domReference, i = m == null || (t = m.nodesRef.current.find((e) => e.id === h)) == null || (t = t.context) == null ? void 0 : t.elements.floating;
				return i && (i.style.pointerEvents = ""), n.style.pointerEvents = "none", r.style.pointerEvents = "auto", e.style.pointerEvents = "auto", () => {
					n.style.pointerEvents = "", r.style.pointerEvents = "", e.style.pointerEvents = "";
				};
			}
		}
	}, [
		c,
		n,
		h,
		o,
		m,
		g,
		O
	]), Z(() => {
		n || (b.current = void 0, D.current = !1, A(), j());
	}, [
		n,
		A,
		j
	]), s.useEffect(() => () => {
		A(), $(x), $(C), j();
	}, [
		c,
		o.domReference,
		A,
		j
	]);
	let N = s.useMemo(() => {
		function e(e) {
			b.current = e.pointerType;
		}
		return {
			onPointerDown: e,
			onPointerEnter: e,
			onMouseMove(e) {
				let { nativeEvent: t } = e;
				function i() {
					!w.current && !v.current && r(!0, t, "hover");
				}
				d && !ln(b.current) || n || Jr(y.current) === 0 || D.current && e.movementX ** 2 + e.movementY ** 2 < 2 || ($(C), b.current === "touch" ? i() : (D.current = !0, C.current = window.setTimeout(i, Jr(y.current))));
			}
		};
	}, [
		d,
		r,
		n,
		v,
		y
	]);
	return s.useMemo(() => c ? { reference: N } : {}, [c, N]);
}
var Xr = {
	border: 0,
	clip: "rect(0 0 0 0)",
	height: "1px",
	margin: "-1px",
	overflow: "hidden",
	padding: 0,
	position: "fixed",
	whiteSpace: "nowrap",
	width: "1px",
	top: 0,
	left: 0
}, Zr = /*#__PURE__*/ s.forwardRef(function(e, t) {
	let [n, r] = s.useState();
	Z(() => {
		$t() && r("button");
	}, []);
	let i = {
		ref: t,
		tabIndex: 0,
		role: n,
		"aria-hidden": !n || void 0,
		[Gr("focus-guard")]: "",
		style: Xr
	};
	return /*#__PURE__*/ a("span", {
		...e,
		...i
	});
}), Qr = {
	clipPath: "inset(50%)",
	position: "fixed",
	top: 0,
	left: 0
}, $r = /*#__PURE__*/ s.createContext(null), ei = /*#__PURE__*/ Gr("portal");
function ti(e) {
	e === void 0 && (e = {});
	let { id: t, root: n } = e, r = Fr(), i = ri(), [a, o] = s.useState(null), c = s.useRef(null);
	return Z(() => () => {
		a?.remove(), queueMicrotask(() => {
			c.current = null;
		});
	}, [a]), Z(() => {
		if (!r || c.current) return;
		let e = t ? document.getElementById(t) : null;
		if (!e) return;
		let n = document.createElement("div");
		n.id = r, n.setAttribute(ei, ""), e.appendChild(n), c.current = n, o(n);
	}, [t, r]), Z(() => {
		if (n === null || !r || c.current) return;
		let e = n || i?.portalNode;
		e && !Le(e) && (e = e.current), e ||= document.body;
		let a = null;
		t && (a = document.createElement("div"), a.id = t, e.appendChild(a));
		let s = document.createElement("div");
		s.id = r, s.setAttribute(ei, ""), e = a || e, e.appendChild(s), c.current = s, o(s);
	}, [
		t,
		n,
		r,
		i
	]), a;
}
function ni(e) {
	let { children: t, id: n, root: r, preserveTabOrder: i = !0 } = e, c = ti({
		id: n,
		root: r
	}), [l, u] = s.useState(null), d = s.useRef(null), f = s.useRef(null), p = s.useRef(null), m = s.useRef(null), h = l?.modal, _ = l?.open, v = !!l && !l.modal && l.open && i && !!(r || c);
	return s.useEffect(() => {
		if (!c || !i || h) return;
		function e(e) {
			c && vn(e) && (e.type === "focusin" ? bn : yn)(c);
		}
		return c.addEventListener("focusin", e, !0), c.addEventListener("focusout", e, !0), () => {
			c.removeEventListener("focusin", e, !0), c.removeEventListener("focusout", e, !0);
		};
	}, [
		c,
		i,
		h
	]), s.useEffect(() => {
		c && (_ || bn(c));
	}, [_, c]), /*#__PURE__*/ o($r.Provider, {
		value: s.useMemo(() => ({
			preserveTabOrder: i,
			beforeOutsideRef: d,
			afterOutsideRef: f,
			beforeInsideRef: p,
			afterInsideRef: m,
			portalNode: c,
			setFocusManagerState: u
		}), [i, c]),
		children: [
			v && c && /*#__PURE__*/ a(Zr, {
				"data-type": "outside",
				ref: d,
				onFocus: (e) => {
					if (vn(e, c)) {
						var t;
						(t = p.current) == null || t.focus();
					} else _n(l ? l.domReference : null)?.focus();
				}
			}),
			v && c && /*#__PURE__*/ a("span", {
				"aria-owns": c.id,
				style: Qr
			}),
			c && /*#__PURE__*/ g.createPortal(t, c),
			v && c && /*#__PURE__*/ a(Zr, {
				"data-type": "outside",
				ref: f,
				onFocus: (e) => {
					if (vn(e, c)) {
						var t;
						(t = m.current) == null || t.focus();
					} else gn(l ? l.domReference : null)?.focus(), l != null && l.closeOnFocusOut && l?.onOpenChange(!1, e.nativeEvent, "focus-out");
				}
			})
		]
	});
}
var ri = () => s.useContext($r);
function ii(e) {
	let { open: t = !1, onOpenChange: n, elements: r } = e, i = Fr(), a = s.useRef({}), [o] = s.useState(() => Br()), c = Ur() != null;
	if (process.env.NODE_ENV !== "production") {
		let e = r.reference;
		e && !H(e) && Rr("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
	}
	let [l, u] = s.useState(r.reference), d = pn((e, t, r) => {
		a.current.openEvent = e ? t : void 0, o.emit("openchange", {
			open: e,
			event: t,
			reason: r,
			nested: c
		}), n?.(e, t, r);
	}), f = s.useMemo(() => ({ setPositionReference: u }), []), p = s.useMemo(() => ({
		reference: l || r.reference || null,
		floating: r.floating || null,
		domReference: r.reference
	}), [
		l,
		r.reference,
		r.floating
	]);
	return s.useMemo(() => ({
		dataRef: a,
		open: t,
		onOpenChange: d,
		elements: p,
		events: o,
		floatingId: i,
		refs: f
	}), [
		t,
		d,
		p,
		o,
		i,
		f
	]);
}
function ai(e) {
	let { elements: t, ...n } = e === void 0 ? {} : e, { nodeId: r } = n, i = ii({
		...n,
		elements: {
			reference: t?.reference ?? null,
			floating: t?.floating ?? null
		}
	}), a = n.rootContext || i, o = a.elements, [c, l] = s.useState(null), [u, d] = s.useState(null), f = o?.domReference || c, p = s.useRef(null), m = Wr();
	Z(() => {
		f && (p.current = f);
	}, [f]);
	let h = hr({
		...n,
		elements: {
			...o,
			...u && { reference: u }
		}
	}), g = s.useCallback((e) => {
		let t = H(e) ? {
			getBoundingClientRect: () => e.getBoundingClientRect(),
			getClientRects: () => e.getClientRects(),
			contextElement: e
		} : e;
		d(t), h.refs.setReference(t);
	}, [h.refs]), _ = s.useCallback((e) => {
		(H(e) || e === null) && (p.current = e, l(e)), (H(h.refs.reference.current) || h.refs.reference.current === null || e !== null && !H(e)) && h.refs.setReference(e);
	}, [h.refs]), v = s.useMemo(() => ({
		...h.refs,
		setReference: _,
		setPositionReference: g,
		domReference: p
	}), [
		h.refs,
		_,
		g
	]), y = s.useMemo(() => ({
		...h.elements,
		domReference: f
	}), [h.elements, f]), b = s.useMemo(() => ({
		...h,
		...a,
		refs: v,
		elements: y,
		nodeId: r
	}), [
		h,
		v,
		y,
		r,
		a
	]);
	return Z(() => {
		a.dataRef.current.floatingContext = b;
		let e = m?.nodesRef.current.find((e) => e.id === r);
		e && (e.context = b);
	}), s.useMemo(() => ({
		...h,
		context: b,
		refs: v,
		elements: y
	}), [
		h,
		v,
		y,
		b
	]);
}
function oi() {
	return en() && $t();
}
function si(e, t) {
	t === void 0 && (t = {});
	let { open: n, onOpenChange: r, events: i, dataRef: a, elements: o } = e, { enabled: c = !0, visibleOnly: l = !0 } = t, u = s.useRef(!1), d = s.useRef(-1), f = s.useRef(!0);
	s.useEffect(() => {
		if (!c) return;
		let e = B(o.domReference);
		function t() {
			!n && U(o.domReference) && o.domReference === rn(X(o.domReference)) && (u.current = !0);
		}
		function r() {
			f.current = !0;
		}
		function i() {
			f.current = !1;
		}
		return e.addEventListener("blur", t), oi() && (e.addEventListener("keydown", r, !0), e.addEventListener("pointerdown", i, !0)), () => {
			e.removeEventListener("blur", t), oi() && (e.removeEventListener("keydown", r, !0), e.removeEventListener("pointerdown", i, !0));
		};
	}, [
		o.domReference,
		n,
		c
	]), s.useEffect(() => {
		if (!c) return;
		function e(e) {
			let { reason: t } = e;
			(t === "reference-press" || t === "escape-key") && (u.current = !0);
		}
		return i.on("openchange", e), () => {
			i.off("openchange", e);
		};
	}, [i, c]), s.useEffect(() => () => {
		$(d);
	}, []);
	let p = s.useMemo(() => ({
		onMouseLeave() {
			u.current = !1;
		},
		onFocus(e) {
			if (u.current) return;
			let t = on(e.nativeEvent);
			if (l && H(t)) {
				if (oi() && !e.relatedTarget) {
					if (!f.current && !sn(t)) return;
				} else if (!cn(t)) return;
			}
			r(!0, e.nativeEvent, "focus");
		},
		onBlur(e) {
			u.current = !1;
			let t = e.relatedTarget, n = e.nativeEvent, i = H(t) && t.hasAttribute(Gr("focus-guard")) && t.getAttribute("data-type") === "outside";
			d.current = window.setTimeout(() => {
				let e = rn(o.domReference ? o.domReference.ownerDocument : document);
				!t && e === o.domReference || an(a.current.floatingContext?.refs.floating.current, e) || an(o.domReference, e) || i || r(!1, n, "focus");
			});
		}
	}), [
		a,
		o.domReference,
		r,
		l
	]);
	return s.useMemo(() => c ? { reference: p } : {}, [c, p]);
}
function ci(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = n === "item", a = e;
	if (i && e) {
		let { [Sr]: t, [Cr]: n, ...r } = e;
		a = r;
	}
	return {
		...n === "floating" && {
			tabIndex: -1,
			[xr]: ""
		},
		...a,
		...t.map((t) => {
			let r = t ? t[n] : null;
			return typeof r == "function" ? e ? r(e) : null : r;
		}).concat(e).reduce((e, t) => (t && Object.entries(t).forEach((t) => {
			let [n, a] = t;
			if (!(i && [Sr, Cr].includes(n))) if (n.indexOf("on") === 0) {
				if (r.has(n) || r.set(n, []), typeof a == "function") {
					var o;
					(o = r.get(n)) == null || o.push(a), e[n] = function() {
						var e = [...arguments];
						return r.get(n)?.map((t) => t(...e)).find((e) => e !== void 0);
					};
				}
			} else e[n] = a;
		}), e), {})
	};
}
function li(e) {
	e === void 0 && (e = []);
	let t = e.map((e) => e?.reference), n = e.map((e) => e?.floating), r = e.map((e) => e?.item), i = s.useCallback((t) => ci(t, e, "reference"), t), a = s.useCallback((t) => ci(t, e, "floating"), n), o = s.useCallback((t) => ci(t, e, "item"), r);
	return s.useMemo(() => ({
		getReferenceProps: i,
		getFloatingProps: a,
		getItemProps: o
	}), [
		i,
		a,
		o
	]);
}
//#endregion
//#region src/components/overlay/Tooltip/types.ts
var ui = {
	top: "top",
	bottom: "bottom",
	left: "left",
	right: "right"
}, di = {
	dark: "dark",
	light: "light"
}, fi = {
	static: "static",
	dynamic: "dynamic"
}, pi = 12, mi = 8, hi = 12, gi = 8, _i = (e) => {
	let { children: t, content: n, placement: r = ui.top, variant: s = di.dark, visible: c, showCaret: u = !0, className: f, ...p } = e, g = d(), _ = m(null), [v, y] = h(!1), b = c !== void 0, x = b ? c : v, { refs: S, floatingStyles: C, context: w } = ai({
		placement: r,
		open: x,
		onOpenChange: y,
		middleware: [
			_r(pi),
			yr(),
			vr({ padding: mi }),
			br({ element: _ })
		],
		whileElementsMounted: ir
	}), { getReferenceProps: T, getFloatingProps: E } = li([Yr(w, {
		enabled: !b,
		move: !1
	}), si(w, { enabled: !b })]), D = l(t, { "aria-describedby": [t.props["aria-describedby"], x ? g : void 0].filter(Boolean).join(" ") || void 0 }), O = ["tooltip-wrapper", f].filter(Boolean).join(" ");
	return /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a("span", {
		ref: S.setReference,
		className: O,
		...T(p),
		children: D
	}), x && /* @__PURE__ */ a(ni, { children: /* @__PURE__ */ o("span", {
		...E(),
		ref: S.setFloating,
		id: g,
		role: "tooltip",
		className: `tooltip-surface tooltip-variant-${s}`,
		style: C,
		children: [/* @__PURE__ */ a("span", {
			className: "tooltip-content",
			children: n
		}), u && /* @__PURE__ */ a(zr, {
			ref: _,
			context: w,
			className: `tooltip-dynamic-arrow-${s}`,
			width: hi,
			height: gi
		})]
	}) })] });
}, vi = (e) => {
	let { children: t, content: n, placement: r = ui.top, variant: i = di.dark, visible: s, showCaret: c = !0, className: u, ...f } = e, p = d(), m = [t.props["aria-describedby"], p].filter(Boolean).join(" "), h = [
		"tooltip-wrapper",
		s === !0 && "tooltip-wrapper-visible",
		s === !1 && "tooltip-wrapper-hidden",
		u
	].filter(Boolean).join(" "), g = l(t, { "aria-describedby": m });
	return /* @__PURE__ */ o("span", {
		className: h,
		...f,
		children: [g, /* @__PURE__ */ o("span", {
			id: p,
			role: "tooltip",
			className: `tooltip-box tooltip-variant-${i}`,
			"data-placement": r,
			children: [/* @__PURE__ */ a("span", {
				className: "tooltip-content",
				children: n
			}), c && /* @__PURE__ */ a("span", { className: "tooltip-caret" })]
		})]
	});
}, yi = (e) => {
	let { position: t = fi.static, ...n } = e;
	return t === fi.dynamic ? /* @__PURE__ */ a(_i, { ...n }) : /* @__PURE__ */ a(vi, { ...n });
}, bi = [
	"informational",
	"positive",
	"negative"
], xi = {
	informational: L.USER_INTERFACE_EXCLAMATION_MARK_CIRCLE,
	positive: L.USER_INTERFACE_CHECKMARK_CIRCLE,
	negative: L.USER_INTERFACE_EXCLAMATION_MARK_TRIANGLE
}, Si = ({ children: e, variant: t = "informational", onClose: n, className: r, ...i }) => {
	let s = [
		"toast",
		`variant-${t}`,
		r
	].filter(Boolean).join(" "), c = xi[t];
	return /* @__PURE__ */ o("div", {
		className: s,
		role: "alert",
		...i,
		children: [/* @__PURE__ */ o("div", {
			className: "toast-content",
			children: [/* @__PURE__ */ a("span", {
				className: "toast-icon",
				children: /* @__PURE__ */ a(k, {
					name: c,
					size: 16
				})
			}), /* @__PURE__ */ a("span", {
				className: "toast-text",
				children: e
			})]
		}), n ? /* @__PURE__ */ a("div", {
			className: "toast-actions",
			children: /* @__PURE__ */ a(P, {
				"aria-label": "Close",
				icon: L.USER_INTERFACE_CLOSE_BOLD,
				iconPosition: N.leading,
				iconSize: 8,
				intent: "neutral",
				onClick: n,
				size: "xs",
				variant: "ghost"
			})
		}) : null]
	});
}, Ci = L.USER_INTERFACE_CHECKMARK, wi = {
	unchecked: "unchecked",
	checked: "checked",
	omitted: "omitted",
	implicit: "implicit",
	mixed: "mixed"
}, Ti = (e) => {
	switch (e) {
		case "checked":
		case "implicit": return !0;
		case "mixed": return "mixed";
		case "omitted":
		case "unchecked": return !1;
	}
}, Ei = ({ state: e, onChange: t, disabled: n = !1, ...r }) => {
	let i = [
		"checkbox",
		`state-${e}`,
		n ? "disabled" : null
	].filter(Boolean).join(" ");
	return /* @__PURE__ */ a("button", {
		"aria-checked": Ti(e),
		className: i,
		disabled: n,
		role: "checkbox",
		type: "button",
		onClick: t,
		...r,
		children: /* @__PURE__ */ o("span", {
			"aria-hidden": "true",
			className: "checkbox-box",
			children: [
				(e === "checked" || e === "implicit") && /* @__PURE__ */ a(k, {
					color: "white",
					name: Ci,
					size: 10
				}),
				e === "omitted" && /* @__PURE__ */ a(k, {
					color: "white",
					name: L.USER_INTERFACE_CLOSE_BOLD,
					size: 8
				}),
				e === "mixed" && /* @__PURE__ */ a("span", { className: "checkbox-mixed-bar" })
			]
		})
	});
}, Di = {
	small: "small",
	medium: "medium",
	large: "large"
}, Oi = "--fill", ki = (e) => /* @__PURE__ */ a("svg", {
	viewBox: "0 0 200 250.2",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("circle", {
		cx: "140.8",
		cy: "59.2",
		r: "59.2"
	})
}), Ai = (e) => /* @__PURE__ */ o("svg", {
	viewBox: "0 0 200 250.2",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", { d: "M93.1,250.2l-59.9-24.4C13.1,217.6,0,198.1,0,176.5V59.2l59.7,24.3c20.2,8.2,33.4,27.8,33.4,49.6V250.2z" }), /* @__PURE__ */ a("circle", {
		cx: "140.8",
		cy: "59.2",
		r: "59.2"
	})]
}), ji = (e) => {
	let { label: t, sublabel: n, progress: r, size: i = Di.medium, className: s, ...c } = e, l = r === void 0, u = l ? 0 : Math.min(1, Math.max(0, r / 100)), f = { [Oi]: u }, p = [
		"rwave-loader",
		`rwave-loader-size-${i}`,
		l ? "rwave-loader-indeterminate" : null,
		s
	].filter(Boolean).join(" "), m = d(), h = `${m}-label`, g = `${m}-sublabel`, _ = [t ? h : null, n ? g : null].filter(Boolean).join(" "), v = _ ? { "aria-labelledby": _ } : { "aria-label": "Loading" };
	return /* @__PURE__ */ o("div", {
		className: p,
		...l ? {
			role: "status",
			"aria-live": "polite",
			...v
		} : {
			role: "progressbar",
			"aria-valuenow": Math.round(u * 100),
			"aria-valuemin": 0,
			"aria-valuemax": 100,
			...v
		},
		...c,
		children: [
			/* @__PURE__ */ o("div", {
				className: "rwave-loader-logo",
				style: f,
				children: [
					/* @__PURE__ */ a(Ai, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-track"
					}),
					/* @__PURE__ */ a(Ai, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-wave rwave-loader-back-wave rwave-loader-back-wave-breathing"
					}),
					/* @__PURE__ */ a(Ai, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-wave rwave-loader-fill rwave-loader-fill-breathing"
					}),
					/* @__PURE__ */ a(ki, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-dot-pulse"
					})
				]
			}),
			t ? /* @__PURE__ */ a("p", {
				className: "rwave-loader-label",
				id: h,
				children: t
			}) : null,
			n ? /* @__PURE__ */ a("p", {
				className: "rwave-loader-sublabel",
				id: g,
				children: n
			}) : null
		]
	});
}, Mi = { glyph: "glyph" }, Ni = 200, Pi = 250.2, Fi = Ni / Pi, Ii = (e) => typeof e == "number" ? e * Fi : void 0, Li = ({ variant: e = Mi.glyph, size: t = 24, title: n, className: r, ...i }) => {
	let s = ["regard-mark", r].filter(Boolean).join(" "), c = n ? {
		role: "img",
		"aria-label": n
	} : { "aria-hidden": !0 };
	return /* @__PURE__ */ o("svg", {
		className: s,
		height: t,
		viewBox: `0 0 ${Ni} ${Pi}`,
		width: Ii(t),
		xmlns: "http://www.w3.org/2000/svg",
		...c,
		...i,
		children: [/* @__PURE__ */ a("path", { d: "M93.1,250.2l-59.9-24.4C13.1,217.6,0,198.1,0,176.5V59.2l59.7,24.3c20.2,8.2,33.4,27.8,33.4,49.6V250.2z" }), /* @__PURE__ */ a("circle", {
			cx: "140.8",
			cy: "59.2",
			r: "59.2"
		})]
	});
}, Ri = {
	small: "small",
	medium: "medium"
}, zi = {
	leading: "leading",
	trailing: "trailing"
}, Bi = {
	small: 14,
	medium: 16
}, Vi = (e, t) => {
	let n = e.iconPosition ?? zi.leading, r = e.label === void 0, s = e.icon === void 0 ? null : /* @__PURE__ */ a(k, {
		name: e.icon,
		size: t
	});
	return /* @__PURE__ */ o(i, { children: [
		n === zi.leading && s,
		!r && /* @__PURE__ */ a("span", {
			className: "segment-label",
			children: e.label
		}),
		n === zi.trailing && s
	] });
}, Hi = (e, t, n) => {
	let r = t.indexOf(e);
	return r === -1 || t.length === 0 ? null : n === "Home" ? t[0] ?? null : n === "End" ? t[t.length - 1] ?? null : t[(r + (n === "ArrowRight" || n === "ArrowDown" ? 1 : -1) + t.length) % t.length] ?? null;
}, Ui = (e) => {
	let { disabled: t = !1, items: n, onValueChange: r, size: i = Ri.medium, value: o, onKeyDown: s, className: c, ...l } = e, u = Bi[i], [d, f] = h(() => {
		let e = n.filter((e) => !(t || e.disabled)).map((e) => e.value);
		return e.includes(o) ? o : e[0];
	});
	return /* @__PURE__ */ a("div", {
		className: (0, I.default)("segmented-control", `size-${i}`, c),
		role: "group",
		onKeyDown: (e) => {
			if (s?.(e), e.defaultPrevented) return;
			let t = e.target;
			if (!(t instanceof HTMLButtonElement) || t.dataset.segmentValue === void 0) return;
			let n = e.key === "ArrowLeft", i = e.key === "ArrowRight", a = e.key === "Home" || e.key === "End";
			if (e.key === "Enter" || e.key === " ") {
				let n = t.dataset.segmentValue;
				n !== void 0 && (e.preventDefault(), r(n));
				return;
			}
			if (!n && !i && !a) return;
			let o = Hi(t, Array.from(e.currentTarget.querySelectorAll("button[data-segment-value]:not(:disabled)")), e.key);
			o !== null && (e.preventDefault(), o.focus());
		},
		...l,
		children: n.map((e) => {
			let n = e.label === void 0, i = o === e.value, s = d === e.value, c = t || !!e.disabled;
			return /* @__PURE__ */ a("button", {
				"aria-label": e["aria-label"],
				"aria-pressed": i,
				className: (0, I.default)("segment", { "icon-only": n }),
				"data-disabled": c ? "" : void 0,
				"data-state": i ? "active" : "inactive",
				"data-segment-value": e.value,
				disabled: c,
				tabIndex: s ? 0 : -1,
				type: "button",
				onClick: () => r(e.value),
				onFocus: () => f(e.value),
				children: Vi(e, u)
			}, e.value);
		})
	});
}, Wi = {
	none: "none",
	md: "md"
}, Gi = {
	none: "none",
	sm: "sm",
	md: "md",
	lg: "lg",
	xl: "xl"
}, Ki = (e) => {
	let { padding: t = Wi.md, elevation: n = Gi.sm, borderColor: r, clipContent: i = !1, className: o, style: s, ...c } = e, l = r === void 0 ? void 0 : { "--card-border-color": `var(--color-${r})` };
	return /* @__PURE__ */ a("div", {
		className: (0, I.default)("card", `card--padding-${t}`, `card--elevation-${n}`, { "card--clip": i }, o),
		style: {
			...s,
			...l
		},
		...c
	});
}, qi = {
	h2: "h2",
	h3: "h3",
	h4: "h4"
}, Ji = (e) => {
	let { title: t, subtitle: n, titleAs: r = qi.h2, footer: i, headerAction: s, borderColor: c, children: l, className: u, ...f } = e, p = d();
	return /* @__PURE__ */ a("section", {
		className: (0, I.default)("section-card", u),
		"aria-labelledby": p,
		...f,
		children: /* @__PURE__ */ o(Ki, {
			className: "section-card-stack",
			padding: "none",
			borderColor: c,
			children: [
				/* @__PURE__ */ o("div", {
					className: "section-card-header",
					children: [
						/* @__PURE__ */ a(r, {
							id: p,
							className: "section-card-title",
							children: t
						}),
						s !== void 0 && /* @__PURE__ */ a("div", {
							className: "section-card-header-action",
							children: s
						}),
						n !== void 0 && /* @__PURE__ */ a("p", {
							className: "section-card-subtitle",
							children: n
						})
					]
				}),
				/* @__PURE__ */ a("div", {
					className: "section-card-body",
					children: l
				}),
				i !== void 0 && /* @__PURE__ */ a("div", {
					className: "section-card-footer",
					children: i
				})
			]
		})
	});
}, Yi = (e) => {
	let { title: t, defaultOpen: n = !0, borderColor: r = "grey-200", headerEnd: i, children: s, className: c, ...l } = e, [u, f] = h(n), p = d();
	return /* @__PURE__ */ o(Ki, {
		className: (0, I.default)("collapsible-card", c),
		padding: "none",
		clipContent: !0,
		borderColor: r,
		elevation: "none",
		...l,
		children: [/* @__PURE__ */ o("div", {
			className: (0, I.default)("collapsible-card-header-bar", { "collapsible-card-header-bar--with-end": i != null }),
			children: [/* @__PURE__ */ o("button", {
				type: "button",
				className: "collapsible-card-header",
				"aria-expanded": u,
				"aria-controls": p,
				onClick: () => f((e) => !e),
				children: [/* @__PURE__ */ a("span", {
					className: "collapsible-card-chevron",
					"data-open": u,
					"aria-hidden": "true",
					children: /* @__PURE__ */ a(k, {
						name: L.ARROWS_CHEVRON_DOWN,
						size: 14,
						color: "grey"
					})
				}), /* @__PURE__ */ a("span", {
					className: "collapsible-card-title",
					children: t
				})]
			}), i != null && /* @__PURE__ */ a("div", {
				className: "collapsible-card-header-end",
				children: i
			})]
		}), u && /* @__PURE__ */ a("div", {
			id: p,
			className: "collapsible-card-body",
			children: s
		})]
	});
};
//#endregion
export { De as AVATAR_COLORS, Ee as AVATAR_SIZES, Oe as Avatar, te as BADGE_COLORS, ee as BADGE_SIZES, F as BADGE_TYPES, A as BUTTON_COLORS, M as BUTTON_SIZES, j as BUTTON_STYLES, re as Badge, P as Button, Gi as CARD_ELEVATIONS, Wi as CARD_PADDINGS, wi as CHECKBOX_STATES, ae as CHIP_COLORS, ie as CHIP_SIZES, se as CHIP_STATES, oe as CHIP_VARIANTS, Ki as Card, Ei as Checkbox, ue as Chip, Yi as CollapsibleCard, D as ICON_COLORS, L as ICON_NAMES, k as Icon, Ce as MENU_ITEM_SELECTED_INDICATORS, Se as Menu, we as MenuItem, n as RADIO_BUTTON_SIZES, r as RADIO_GROUP_ORIENTATIONS, Mi as REGARD_MARK_VARIANTS, Di as RWAVE_LOADER_SIZES, ji as RWaveLoader, e as RadioButton, t as RadioGroup, Li as RegardMark, qi as SECTION_CARD_TITLE_ELEMENTS, zi as SEGMENTED_CONTROL_ICON_POSITIONS, Ri as SEGMENTED_CONTROL_SIZES, ke as SearchInput, Ji as SectionCard, Ui as SegmentedControl, de as TAB_BAR_SIZES, fe as TAB_ICON_POSITIONS, Ae as TEXT_INPUT_SIZE, R as TEXT_INPUT_STATE, bi as TOAST_VARIANTS, ui as TOOLTIP_PLACEMENTS, fi as TOOLTIP_POSITIONS, di as TOOLTIP_VARIANTS, ve as TabBar, Fe as TextInput, Si as Toast, yi as Tooltip, Te as getInitials };
